import * as Config from "./Config";
import type {
  CompleteNethoneProfileReturn,
  DelAttemptReferenceReturn,
  GetAttemptReferenceReturn,
  SetAttemptReferenceReturn
} from "./Types/Returns";

function SetAttemptReference(): SetAttemptReferenceReturn {
  let ReturnObject: SetAttemptReferenceReturn = {} as SetAttemptReferenceReturn;
  const UuidPattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  const UUIDV4 = () =>
    UuidPattern.replace(/[xy]/g, (Char: string) => {
      let Rule = (Math.random() * 16) | 0;
      let Value = Char === "x" ? Rule : (Rule & 0x3) | 0x8;
      return Value.toString(16);
    });
  ReturnObject.ref = UUIDV4();
  ReturnObject.status = Boolean(ReturnObject.ref);
  document.cookie = `${Config.cookieName}=${
    ReturnObject.ref
  }; path=/; max-age=${60 * 60 * 24 * 90};`;
  return ReturnObject;
}

function GetAttemptReference(): GetAttemptReferenceReturn {
  let ReturnObject: GetAttemptReferenceReturn = {} as GetAttemptReferenceReturn;
  const IsClientSide = typeof document !== "undefined";
  if (IsClientSide) {
    const Cookies = `;${document.cookie}`;
    let Parts = Cookies.split(`; ${Config.cookieName}=`);
    let Nethone = null;
    if (Parts.length === 2) {
      Nethone = Parts.pop().split(";").shift();
      ReturnObject.created = false;
    } else {
      ReturnObject.created = true;
      Nethone = SetAttemptReference().ref;
    }
    ReturnObject.ref = Nethone;
  } else {
    ReturnObject.created = false;
    ReturnObject.ref = null;
  }
  return ReturnObject;
}

function DelAttemptReference(): DelAttemptReferenceReturn {
  let ReturnObject: DelAttemptReferenceReturn = {} as DelAttemptReferenceReturn;
  const IsClientSide = typeof document !== "undefined";
  if (IsClientSide) {
    document.cookie = `${Config.cookieName}= ; expires = Thu, 01 Jan 1970 00:00:00 GMT`;
    ReturnObject.status = true;
  } else {
    ReturnObject.status = false;
  }
  return ReturnObject;
}

// @ts-ignore
async function CompleteNethoneProfile(
  CallbackFunction: Function = null
): Promise<CompleteNethoneProfileReturn> {
  const ReturnObject: CompleteNethoneProfileReturn =
    {} as CompleteNethoneProfileReturn;
  const IsClientSide = typeof window !== "undefined";
  if (IsClientSide) {
    const Profiler = window["dftp"];
    if (Profiler) {
      await Profiler["profileCompleted"]()
        .catch((Err: any) => {
          ReturnObject.done = false;
        })
        .then(() => {
          ReturnObject.done = true;
        });
      CallbackFunction ? CallbackFunction() : null;
    } else {
      ReturnObject.done = false;
      CallbackFunction ? CallbackFunction() : null;
    }
  } else {
    ReturnObject.done = false;
    CallbackFunction ? CallbackFunction() : null;
  }
  return ReturnObject;
}

export {
  SetAttemptReference,
  GetAttemptReference,
  DelAttemptReference,
  CompleteNethoneProfile
};
